import firebase from 'firebase/app';

export  const SaveSearchLastFive = (fbProfile, auth, profile, url, sendArr, message, foundInts, docId) => {

    firebase
        .firestore()
        .collection('organizations')
        .doc(fbProfile.company)
        .collection('searchedContactLastFive')
        .doc(auth.uid)
        .collection('searchedContact')
        .doc(docId)
        .set({
            contactImg: profile?.profile_pic_url ? profile?.profile_pic_url : '',
            contactFirstName: profile.first_name ? profile.first_name : '',
            contactLastName: profile.last_name ? profile.first_name : '',     
            contactName: profile.full_name ? profile.full_name : profile.ProspectName,
            contactCompany: (profile.experiences?.length > 0) ? profile.experiences[0].company : '',
            contactRole: profile.occupation ? profile.occupation : '',
            contactEducation: profile?.education?.[0]?.school ? profile?.education?.[0]?.school : '',
            contactFieldOfStudy: profile?.education?.[0]?.field_of_study ? profile?.education?.[0]?.field_of_study : '',
            contactHeadline: profile.headline ? profile.headline : (profile.ProspectRole ? profile.ProspectRole : ''),
            contactCity: profile.city ? profile.city : (profile.contactCity ? profile.contactCity : ''),
            contactLinkdinUrl: url,
            contactInterest: sendArr,
            contactContent: foundInts,
            contactActivities: (profile?.activities?.length > 0) ? profile.activities : '',
            contactArticles: (profile?.articles?.length > 0) ? profile.articles : '',
            contactSummary: profile?.summary ? profile.summary : '',
            contactExp: profile?.experiences?.[0] ? profile.experiences?.[0] : '',
            message: message,
            createdBy: fbProfile.email,
            authorID: auth.uid,
            authorFirstName: fbProfile.firstName,
            authorLastName: fbProfile.lastName,
            authorCompany: fbProfile.company,
            createdAt: new Date(),
            docId: docId
        })
}
